import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { Signature } from '../../../services/commands/types';
import { SignatureButtonFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';
import { AppState } from '../../../store/reducers/root';
import {
  getControlValue,
  getFormControlByName,
} from '../../../store/selectors/form';
import {
  getAllowedDSMediaTypes,
  getAvailableDSAgents,
  getAvailableDSKeyTypes,
  getForbiddenDSMediaTypes,
  getSignAlgo,
} from '../../../store/selectors/session';
import form from '../../../store/slices/form';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormSignatureButtonControl from './FormSignatureButtonControl';

type OwnProps = Omit<
  TFormControlConnectorProps,
  'onChange' | 'onChanged' | 'onSubmit'
>;

const mapStateToProps = (
  state: AppState,
  { formId, control: { name } }: OwnProps
) => {
  const control = getFormControlByName(
    state,
    formId,
    name
  ) as SignatureButtonFormControlViewModel;
  const signData = control.documentControl.map<string>(
    documentControl => getControlValue(state, formId, documentControl) ?? ''
  );
  return {
    signData,
    dsAgents: getAvailableDSAgents(state),
    dsKeyTypes: getAvailableDSKeyTypes(state),
    allowedDSMediaTypes: getAllowedDSMediaTypes(state),
    forbiddenDSMediaTypes: getForbiddenDSMediaTypes(state),
    label: control.label,
    signAlgo: getSignAlgo(state),
    signatureControlsNames: control.signatureControl,
    signatureType: control.signatureType,
    disabled: control.disabled,
  };
};

const mapDispatchToProps = {
  onError: form.signFailure,
  onSign: form.sign,
};

const mergeProps = (
  { signatureControlsNames, ...msP }: ReturnType<typeof mapStateToProps>,
  { onError, onSign }: typeof mapDispatchToProps,
  { formId }: OwnProps
) => ({
  ...msP,
  onError: (e: Error) => {
    onError(e);
  },
  onSign: (signatures: Signature[]) => {
    onSign({ formId, names: signatureControlsNames, signatures });
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type FormSignatureButtonControlProps = ConnectedProps<typeof connector>;

export default connector(FormSignatureButtonControl);
